var _style, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMensajes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-new-message",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-new-message:not(.animated) .animable {opacity: 0;}svg#freepik_stories-new-message.animated #freepik--Device--inject-72 {animation: 1.5s Infinite  linear floating;animation-delay: 0s;}svg#freepik_stories-new-message.animated #freepik--Message--inject-72 {animation: 1.5s Infinite  linear floating;animation-delay: 0s;}            @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }        ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-72",
    className: "animable",
    style: {
      transformOrigin: "250px 335.21px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-72",
    cx: 250,
    cy: 335.21,
    rx: 222.46,
    ry: 128.44,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "250px 335.21px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-72",
    className: "animable",
    style: {
      transformOrigin: "236.865px 348.045px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-72",
    d: "M289.94,441.7l109.14-63c2.39-1.38,2.39-3.62,0-5L192.45,254.39a9.57,9.57,0,0,0-8.66,0l-109.14,63c-2.39,1.38-2.39,3.62,0,5L281.28,441.7A9.57,9.57,0,0,0,289.94,441.7Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "236.865px 348.045px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-72",
    className: "animable",
    style: {
      transformOrigin: "83.1576px 283.263px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-72",
    className: "animable",
    style: {
      transformOrigin: "83.1576px 283.263px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.52,319.78l8.56-4.94s2.09-18.32.7-32.51c-2-19.93-14.84-43.92-30.2-38.29s7,25.94,12,42.85S95.52,319.78,95.52,319.78Z",
    style: {
      fill: "current",
      transformOrigin: "87.2644px 281.493px"
    },
    id: "el1csckwd9nau",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eljh08wcmulnk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.52,319.78l8.56-4.94s2.09-18.32.7-32.51c-2-19.93-14.84-43.92-30.2-38.29s7,25.94,12,42.85S95.52,319.78,95.52,319.78Z",
    style: {
      opacity: 0.15,
      transformOrigin: "87.2644px 281.493px"
    },
    className: "animable",
    id: "el8qw95o0zi5d"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M100,317.7h0a.52.52,0,0,1-.5-.53C101,272.87,79,250.58,78.73,250.36a.51.51,0,0,1,0-.73.52.52,0,0,1,.73,0c.22.23,22.6,22.83,21.08,67.58A.52.52,0,0,1,100,317.7Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "89.5951px 283.59px"
    },
    id: "eljrdbn3vci8d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,323.32,97,319.8s1-12.57-5.12-27.84c-5.37-13.3-18.68-24.33-25.38-22S60,277,63.27,282,86.4,298.85,91,323.32Z",
    style: {
      fill: "current",
      transformOrigin: "79.0594px 296.484px"
    },
    id: "eldle0fmke226",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.17,322h0a.52.52,0,0,1-.52-.52c.12-28-26.18-46.94-26.45-47.13a.52.52,0,0,1-.12-.72.51.51,0,0,1,.72-.12c.27.19,27,19.43,26.89,48A.53.53,0,0,1,94.17,322Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "80.8378px 297.706px"
    },
    id: "elea3adas95n4",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-72",
    className: "animable",
    style: {
      transformOrigin: "393.735px 76.7359px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Cloud--inject-72",
    d: "M387.73,54.71l8.62,5a9,9,0,0,1-.08-1.14V56c0-4.44,3.12-6.24,7-4a13.53,13.53,0,0,1,4.15,4c.63-5.58,5-7.66,10.33-4.59,5.75,3.32,10.42,11.4,10.42,18v3.73a9.78,9.78,0,0,1-.89,4.33l7.16,4.13a8.53,8.53,0,0,1,3.86,6.68c0,2.47-1.73,3.46-3.86,2.23L387.73,63.62a8.53,8.53,0,0,1-3.86-6.68C383.87,54.47,385.6,53.47,387.73,54.71Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "411.085px 70.5142px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--cloud--inject-72",
    d: "M352,76.89l6.31,3.64a7.86,7.86,0,0,1,0-.83V77.87c0-3.26,2.28-4.58,5.1-3a9.93,9.93,0,0,1,3,2.93c.46-4.1,3.67-5.62,7.57-3.37a16.89,16.89,0,0,1,7.64,13.22v2.74a7.26,7.26,0,0,1-.65,3.17l5.24,3a6.25,6.25,0,0,1,2.84,4.9c0,1.81-1.27,2.54-2.84,1.63L352,83.43a6.26,6.26,0,0,1-2.83-4.91C349.13,76.72,350.39,76,352,76.89Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "369.11px 88.4352px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-72",
    className: "animable animator-active",
    style: {
      transformOrigin: "238.265px 338.814px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--device--inject-72",
    className: "animable",
    style: {
      transformOrigin: "238.265px 338.814px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--device--inject-72",
    className: "animable",
    style: {
      transformOrigin: "238.265px 338.814px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M392.46,357.27c1.56,1.2,1.39,2.91-.49,4L289,420.74a8.3,8.3,0,0,1-7.49,0L84.59,307.07c-1.91-1.1-2.06-2.83-.44-4a8.36,8.36,0,0,0-3.31,6.2v4.95a8.31,8.31,0,0,0,3.75,6.5L281.44,434.35a8.26,8.26,0,0,0,7.5,0l103-59.46a8.28,8.28,0,0,0,3.75-6.49v-5A8.39,8.39,0,0,0,392.46,357.27Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "238.265px 369.16px"
    },
    id: "ele4s7zad2q6h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392,356.94,195.09,243.27a8.3,8.3,0,0,0-7.49,0l-103,59.48c-2.07,1.19-2.07,3.13,0,4.32L281.46,420.74a8.3,8.3,0,0,0,7.49,0l103-59.48C394,360.07,394,358.13,392,356.94Zm-26.71-9.19c1.77,1,1.77,2.68,0,3.7l-93.66,54.09a7.14,7.14,0,0,1-6.43,0L111.88,317c-1.77-1-1.77-2.69,0-3.71l93.67-54.08c1.77-1,3.62-1.62,5.39-.6Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "238.271px 332.005px"
    },
    id: "elakco2kbgnjt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.15,303a8.36,8.36,0,0,0-3.31,6.2v4.95a8.32,8.32,0,0,0,3.75,6.5L281.44,434.35a7.8,7.8,0,0,0,3.76.9V421.63a7.73,7.73,0,0,1-3.75-.89L84.59,307.07C82.68,306,82.53,304.24,84.15,303Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "183.02px 369.125px"
    },
    id: "eltrpbrhm0rlk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,278.85c1.39-.8,1.39-2.1,0-2.9a5.55,5.55,0,0,0-5,0c-1.39.8-1.39,2.1,0,2.9A5.55,5.55,0,0,0,146,278.85Z",
    id: "elqbgwdcmwx6",
    className: "animable",
    style: {
      transformOrigin: "143.5px 277.4px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.64,387.62c3.27-1.88,3.27-4.94,0-6.82a13,13,0,0,0-11.83,0c-3.27,1.88-3.27,4.94,0,6.82A13,13,0,0,0,336.64,387.62Z",
    style: {
      fill: "none",
      stroke: "rgb(230, 230, 230)",
      strokeMiterlimit: 10,
      transformOrigin: "330.725px 384.21px"
    },
    id: "elm88dijxk7x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.49,288.47l19.4-11.19c1.15-.67,1.21-1.72.13-2.35A4.51,4.51,0,0,0,159,275l-19.4,11.19c-1.15.67-1.21,1.72-.13,2.35A4.51,4.51,0,0,0,143.49,288.47Z",
    id: "elfl59paxdo0w",
    className: "animable",
    style: {
      transformOrigin: "151.245px 281.735px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.94,258.65c-1.77-1-3.62-.43-5.39.6l-93.67,54.08c-1.77,1-1.77,2.68,0,3.71l153.28,88.49a7.14,7.14,0,0,0,6.43,0l93.66-54.09c1.78-1,1.78-2.68,0-3.7Z",
    style: {
      fill: "current",
      transformOrigin: "238.569px 332.212px"
    },
    id: "elu9e2tpasgz8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elkgp4a7ia95"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.94,258.65c-1.77-1-3.62-.43-5.39.6l-93.67,54.08c-1.77,1-1.77,2.68,0,3.71l153.28,88.49a7.14,7.14,0,0,0,6.43,0l93.66-54.09c1.78-1,1.78-2.68,0-3.7Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.85,
      transformOrigin: "238.569px 332.212px"
    },
    className: "animable",
    id: "elywggn810cc"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M122.67,318.19l-1-.58a.24.24,0,0,1,0-.45l.11-.06a.83.83,0,0,1,.78,0l1,.57c.21.13.21.33,0,.45l-.11.07A.89.89,0,0,1,122.67,318.19Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "122.616px 317.641px"
    },
    id: "elfj3hh9hv3nf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.45,317.16l-1.73-1c-.21-.12-.21-.32,0-.45l.11-.06a.89.89,0,0,1,.78,0l1.73,1c.21.12.21.32,0,.45l-.11.06A.89.89,0,0,1,124.45,317.16Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "124.03px 316.405px"
    },
    id: "el3ljm50nihgp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.23,316.13l-2.45-1.41c-.22-.13-.22-.33,0-.45l.11-.07a.89.89,0,0,1,.78,0l2.45,1.42a.24.24,0,0,1,0,.45l-.11.06A.83.83,0,0,1,126.23,316.13Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "125.446px 315.169px"
    },
    id: "el8skc6teu582",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,315.11l-4.23-2.45c-.22-.12-.22-.32,0-.45l.11-.06a.86.86,0,0,1,.78,0l4.22,2.44c.22.13.22.33,0,.45l-.1.07A.89.89,0,0,1,128,315.11Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "126.325px 313.628px"
    },
    id: "elkdvm2o5uca",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.11,312.49a.27.27,0,0,1-.19-.05l-.62-.36-2,1.15a.26.26,0,0,1-.29,0l-.23-.13-.1-.07,0-.1-.1-2.51a.31.31,0,0,1,0-.11.35.35,0,0,1,.12-.09l.27-.16a.63.63,0,0,1,.23-.08.42.42,0,0,1,.21.06l2.17,1.25.44-.25a.49.49,0,0,1,.22-.08.36.36,0,0,1,.2.06l.15.09c.07,0,.1.07.09.11s0,.07-.13.12l-.44.26.62.36c.07,0,.1.07.09.11s-.05.08-.14.13l-.34.19A.42.42,0,0,1,133.11,312.49Zm-1.21-.79-1.55-.89.1,1.73Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "131.698px 311.627px"
    },
    id: "elel59z96waxj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.1,310.91a3.62,3.62,0,0,1-2-.49c-.62-.36-.9-.75-.85-1.17s.44-.83,1.15-1.24a5.43,5.43,0,0,1,.88-.42,4.35,4.35,0,0,1,.83-.23.18.18,0,0,1,.13,0,.1.1,0,0,1,0,.05l.09.26a.06.06,0,0,1,0,.08l-.11,0a3.81,3.81,0,0,0-1.22.47c-.48.27-.74.56-.78.85s.18.58.66.85a2.66,2.66,0,0,0,1.46.39,3,3,0,0,0,1.44-.43,4.39,4.39,0,0,0,.45-.3,1.39,1.39,0,0,0,.3-.29l-1-.58-.83.48a.63.63,0,0,1-.23.08.41.41,0,0,1-.2-.06l-.14-.08q-.1-.06-.09-.12s.05-.07.13-.12l1.33-.77a.56.56,0,0,1,.26-.08.43.43,0,0,1,.23.07l1.44.83a.22.22,0,0,1,.1.08s0,.05,0,.09a3.14,3.14,0,0,1-1.26,1.09A4.69,4.69,0,0,1,135.1,310.91Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "135.387px 309.131px"
    },
    id: "elojq6n0vd0ua",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.78,291.48l2.35,1.36a.72.72,0,0,0,.64,0l2.37-1.36c.17-.11.17-.27,0-.37l-2.36-1.36a.66.66,0,0,0-.64,0l-2.36,1.36C162.6,291.21,162.6,291.37,162.78,291.48Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "165.456px 291.291px"
    },
    id: "el91x5bc406wi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.41,289.63a2.19,2.19,0,0,0-1-.22,2.13,2.13,0,0,0-1,.22c-.46.27-.46.68,0,.94l.81.47.59-.12-.81-.46a.38.38,0,0,1,0-.71.91.91,0,0,1,.42-.11.74.74,0,0,1,.41.11l.81.47.6-.12Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "163.653px 290.225px"
    },
    id: "el30rnsb2cpud",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.32,264.82a2.29,2.29,0,0,0-1.14.26l-6,3.45c-.52.29-.52.76,0,1.06l2.18,1.25a2.29,2.29,0,0,0,1.14.26,3.31,3.31,0,0,0,.55-.05,1.66,1.66,0,0,0,.58-.21l6-3.44c.51-.3.51-.77,0-1.06l-2.18-1.26A2.25,2.25,0,0,0,207.32,264.82Zm-3.8,6a1.05,1.05,0,0,1-.49-.13l-2.17-1.26a.43.43,0,0,1,0-.81l6-3.44a.91.91,0,0,1,.31-.12l.18,0a1,1,0,0,1,.48.14l2.17,1.25a.43.43,0,0,1,0,.81l-6,3.45A1,1,0,0,1,203.52,270.85Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "205.401px 267.96px"
    },
    id: "eljq08emjceu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.69,270.43l-.08-.05-2-1.13a.32.32,0,0,1,0-.6l5.38-3.1a.34.34,0,0,1,.11-.05l.08.05,2,1.13a.32.32,0,0,1,0,.59l-5.38,3.11Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "205.389px 267.965px"
    },
    id: "elw3uhtykjrtj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.76,264.92a1.51,1.51,0,0,1,1.21.23l.4.24c.45.25.64.57.43.71l-.39.24-2-1.19Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "209.648px 265.61px"
    },
    id: "elsw700dxaos",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.59,323.68a9.64,9.64,0,0,0,4.2-1.16c2.44-1.41,3.07-3.33-.8-5.74a4.78,4.78,0,0,1-2.54,3.42c-3.32,1.92-7.1,2.41-10.15.66s-2-4.35,1.34-6.27a14.14,14.14,0,0,1,14.1.05c5.65,3.26,4.38,6.71.38,9a15.91,15.91,0,0,1-6.82,2Zm1.41-7.94c-2.93-1.27-5.42-1.09-7.31,0-1.59.91-1.91,2.24-.15,3.25a5.5,5.5,0,0,0,5.68-.27A3.09,3.09,0,0,0,176,315.74Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "174.024px 319.186px"
    },
    id: "elfhj0t6j6n3o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,309.45a4.38,4.38,0,0,1,4-.28c1,.6.81,1.6-.47,2.33a4.44,4.44,0,0,1-4.07.29C181.43,311.2,181.69,310.19,183,309.45Zm7.81,4.51a4.37,4.37,0,0,1,4-.27c1,.59.81,1.59-.47,2.33a4.47,4.47,0,0,1-4.07.29C189.25,315.72,189.5,314.7,190.78,314Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "188.637px 312.741px"
    },
    id: "elm2nclytl7t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.13,308.51c-4.91-2.84-4.91-5.79-.89-8.12s9.16-2.31,14.06.52,5,5.87,1,8.2S197.05,311.35,192.13,308.51Zm9.81-5.67c-4.11-2.37-6.75-2.35-8.64-1.26s-1.93,2.62,2.18,5,6.93,2.42,8.79,1.35S206.06,305.22,201.94,302.84Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "198.739px 304.734px"
    },
    id: "el4y82oglpztt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.77,299.48c-4.92-2.84-4.92-5.79-.9-8.11s9.17-2.31,14.06.51,5.06,5.88,1,8.2S212.68,302.32,207.77,299.48Zm9.81-5.66c-4.12-2.38-6.76-2.36-8.65-1.27s-1.93,2.62,2.19,5,6.93,2.41,8.78,1.34S221.69,296.19,217.58,293.82Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "214.38px 295.708px"
    },
    id: "elrn21zzexxm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.56,345.63l78.68-45.42a6.65,6.65,0,0,1,6,0l20.11,11.61c1.66,1,1.66,2.51,0,3.47L208.7,360.71a6.65,6.65,0,0,1-6,0L182.56,349.1C180.9,348.14,180.9,346.59,182.56,345.63Z",
    style: {
      fill: "current",
      transformOrigin: "234.955px 330.46px"
    },
    id: "elx6bfkshuvhk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191,347.17l14.08,8.12a2.82,2.82,0,0,0,2.59,0l20.75-12c.72-.42.72-1.09,0-1.5l-14.08-8.13a2.88,2.88,0,0,0-2.59,0l-20.75,12A.79.79,0,0,0,191,347.17Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "209.701px 344.479px"
    },
    id: "eleprx1kyh3jo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.24 343.26 228.93 342.6 212.3 342.35 212.97 333.38 210.24 344.45 190.45 346.41 206.61 345.65 206.21 355.6 207.45 345.61 212.08 345.39 212.24 343.26",
    style: {
      fill: "current",
      transformOrigin: "209.69px 344.49px"
    },
    id: "els3krwkb6gvq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221,329.42l20.33-11.69a3.62,3.62,0,0,1,3.27,0c.89.51.86,1.35-.07,1.89l-20.33,11.69a3.62,3.62,0,0,1-3.27,0C220.05,330.8,220.09,330,221,329.42Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "232.771px 324.52px"
    },
    id: "elnjy8a306pqa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.27,333l41.2-23.81a3.62,3.62,0,0,1,3.27,0c.89.51.86,1.36-.07,1.89l-41.2,23.81a3.65,3.65,0,0,1-3.28,0C226.31,334.41,226.34,333.57,227.27,333Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "249.469px 322.039px"
    },
    id: "elgd0qsyt847b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.52,336.64l41.21-23.81a3.62,3.62,0,0,1,3.27,0c.88.51.85,1.36-.07,1.89l-41.21,23.81a3.62,3.62,0,0,1-3.27,0C232.56,338,232.6,337.18,233.52,336.64Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "255.723px 325.68px"
    },
    id: "elxyn372uy4j9",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Message--inject-72",
    className: "animable",
    style: {
      transformOrigin: "259.135px 178.954px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Envelope--inject-72",
    className: "animable",
    style: {
      transformOrigin: "244.155px 178.954px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.55,181.54l133.38-77,5.34,3.08a5.57,5.57,0,0,1,2.5,4.35v98.39a5.56,5.56,0,0,1-2.5,4.35L183.9,288.81a5.61,5.61,0,0,1-5,0l-2.82-1.63a5.59,5.59,0,0,1-2.51-4.35Z",
    style: {
      fill: "current",
      transformOrigin: "244.16px 196.969px"
    },
    id: "ele0vt6kt0dkk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elaapugk87eij"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.55,181.54l133.38-77,5.34,3.08a5.57,5.57,0,0,1,2.5,4.35v98.39a5.56,5.56,0,0,1-2.5,4.35L183.9,288.81a5.61,5.61,0,0,1-5,0l-2.82-1.63a5.59,5.59,0,0,1-2.51-4.35Z",
    style: {
      opacity: 0.05,
      transformOrigin: "244.16px 196.969px"
    },
    className: "animable",
    id: "elt4jspa7elp"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M306.19,95.88l.55-.3-2.07-1.2h0a4,4,0,0,0-.56-.26l-58.7-21.75a4,4,0,0,0-4.5,1.43l-65.67,95.89a11.44,11.44,0,0,0-1.69,5.48v6.37l2,1.18,131.35-78.19V98.16A4.34,4.34,0,0,0,306.19,95.88Z",
    style: {
      fill: "current",
      transformOrigin: "240.225px 127.441px"
    },
    id: "elcei3jzq5pkr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elw2zo9vwj7zh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.62,74.27a3.32,3.32,0,0,0-.68.72l-65.67,95.89a10.2,10.2,0,0,0-1.22,2.74l-2-1.18a13.1,13.1,0,0,1,.53-1.45l0,0c.09-.2.18-.39.28-.58l0-.09a5.23,5.23,0,0,1,.35-.58L240.9,73.81a3.19,3.19,0,0,1,.33-.4l.35-.32Z",
    style: {
      opacity: 0.1,
      transformOrigin: "208.835px 123.355px"
    },
    className: "animable",
    id: "el7w4n4q2zdk6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el29uqze3js8j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306.71,95.58a3.2,3.2,0,0,0-.56-.27L247.44,73.55a4,4,0,0,0-3.82.72l-2-1.18a4.07,4.07,0,0,1,3.83-.72l58.7,21.75a3.11,3.11,0,0,1,.55.27Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.35,
      transformOrigin: "274.165px 83.8759px"
    },
    className: "animable",
    id: "ellkqxa3ubr2r"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M174.89,170.27a6.36,6.36,0,0,1,.35-.58A6.36,6.36,0,0,0,174.89,170.27Z",
    style: {
      fill: "current",
      transformOrigin: "175.065px 169.98px"
    },
    id: "elpyxbv89whnb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.24,73.41a2.66,2.66,0,0,1,.35-.32A2.15,2.15,0,0,0,241.24,73.41Z",
    style: {
      fill: "current",
      transformOrigin: "241.415px 73.25px"
    },
    id: "el383mnmz1e5a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,172.44a13.27,13.27,0,0,1,.53-1.46A13.27,13.27,0,0,0,174,172.44Z",
    style: {
      fill: "current",
      transformOrigin: "174.265px 171.71px"
    },
    id: "el3l5lc0cdzuw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.56,170.94c.09-.2.19-.39.28-.57C174.75,170.55,174.65,170.74,174.56,170.94Z",
    style: {
      fill: "current",
      transformOrigin: "174.7px 170.655px"
    },
    id: "elt4gtbohoj9k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elohtlofycw9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.54,171l0,0Z",
    style: {
      opacity: 0.2,
      transformOrigin: "174.54px 171px"
    },
    className: "animable",
    id: "elfjdfevgsy7t"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eldebcv2gu0sp"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "174.01 172.44 174.01 172.44 174.01 172.44 174.01 172.44",
    style: {
      opacity: 0.2,
      transformOrigin: "174.01px 172.44px"
    },
    className: "animable",
    id: "elwrmmbid9cit"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elj0c2lrtxez"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "241.59 73.09 241.59 73.09 241.59 73.09 241.59 73.09",
    style: {
      opacity: 0.2,
      transformOrigin: "241.59px 73.09px"
    },
    className: "animable",
    id: "elltjlh33p3c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elyi1d5o2isu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.84,170.37s0-.07,0-.1S174.86,170.34,174.84,170.37Z",
    style: {
      opacity: 0.2,
      transformOrigin: "174.844px 170.317px"
    },
    className: "animable",
    id: "el3gf55hqcb82"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elgube9vxaogv"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.91,73.8a2.44,2.44,0,0,1,.33-.39A2,2,0,0,0,240.91,73.8Z",
    style: {
      opacity: 0.2,
      transformOrigin: "241.075px 73.605px"
    },
    className: "animable",
    id: "el494jjvd9jgk"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M242.94,75l-65.66,95.9a11.27,11.27,0,0,0-1.7,5.47v6.37l133.38-77V99.34a4.64,4.64,0,0,0-2.81-4l-58.7-21.75A4.05,4.05,0,0,0,242.94,75Z",
    style: {
      fill: "current",
      transformOrigin: "242.27px 128.062px"
    },
    id: "elm5aeufg8ni",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.1,275.41l-4.28-2.47h0l0,0v0a2.58,2.58,0,0,1-1-2.33V137.25a7.66,7.66,0,0,1,1.2-3.81l4.35,2.5a7.6,7.6,0,0,0-1.2,3.83V273.08A2.61,2.61,0,0,0,190.1,275.41Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "187.587px 204.425px"
    },
    id: "el0msghzjh3yxe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.77,133.4,299.91,71.56c2-1.18,3.67-.23,3.67,2.12V207a8.11,8.11,0,0,1-3.67,6.37L192.77,275.2c-2,1.17-3.67.22-3.67-2.13V139.77A8.14,8.14,0,0,1,192.77,133.4Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "246.34px 173.377px"
    },
    id: "el8x3qwamnxi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.16,68.79l4.2,2.44a2.6,2.6,0,0,0-2.46.35L192.77,133.41a7.08,7.08,0,0,0-2.48,2.53l-4.35-2.5a7.38,7.38,0,0,1,2.47-2.55L295.55,69a2.52,2.52,0,0,1,2.61-.23Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "244.15px 102.225px"
    },
    id: "el301erdieru",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.13,140.38l89.09-51.44c1.2-.69,2.17-.2,2.17,1.1a4.64,4.64,0,0,1-2.17,3.59l-89.09,51.44c-1.2.69-2.17.2-2.17-1.09A4.64,4.64,0,0,1,201.13,140.38Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "245.675px 117.005px"
    },
    id: "ell0446lkte0n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.13,149.73l89.09-51.44c1.2-.69,2.17-.2,2.17,1.1a4.64,4.64,0,0,1-2.17,3.59l-89.09,51.44c-1.2.69-2.17.2-2.17-1.09A4.64,4.64,0,0,1,201.13,149.73Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "245.675px 126.355px"
    },
    id: "elwzm7nn7x9l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.13,159.08l89.09-51.44c1.2-.69,2.17-.2,2.17,1.09a4.64,4.64,0,0,1-2.17,3.6l-89.09,51.44c-1.2.69-2.17.2-2.17-1.09A4.64,4.64,0,0,1,201.13,159.08Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "245.675px 135.705px"
    },
    id: "el7dglagv0ms5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.13,168.43,290.22,117c1.2-.69,2.17-.2,2.17,1.09a4.64,4.64,0,0,1-2.17,3.6l-89.09,51.44c-1.2.69-2.17.2-2.17-1.1A4.64,4.64,0,0,1,201.13,168.43Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "245.675px 145.065px"
    },
    id: "elgs0i8jamq9p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.13,177.78l89.09-51.44c1.2-.69,2.17-.2,2.17,1.09a4.64,4.64,0,0,1-2.17,3.6l-89.09,51.44c-1.2.69-2.17.2-2.17-1.1A4.64,4.64,0,0,1,201.13,177.78Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "245.675px 154.405px"
    },
    id: "elj8o89bwm08t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.13,187.13l89.09-51.44c1.2-.69,2.17-.2,2.17,1.09a4.64,4.64,0,0,1-2.17,3.6l-89.09,51.44c-1.2.69-2.17.2-2.17-1.1A4.64,4.64,0,0,1,201.13,187.13Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "245.675px 163.755px"
    },
    id: "elylhjkkwlmu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.13,196.48,290.22,145c1.2-.69,2.17-.2,2.17,1.09a4.64,4.64,0,0,1-2.17,3.6l-89.09,51.44c-1.2.69-2.17.2-2.17-1.1A4.64,4.64,0,0,1,201.13,196.48Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "245.675px 173.065px"
    },
    id: "els429wmhktm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.13,205.83l89.09-51.44c1.2-.7,2.17-.2,2.17,1.09a4.64,4.64,0,0,1-2.17,3.6l-89.09,51.44c-1.2.69-2.17.2-2.17-1.1A4.64,4.64,0,0,1,201.13,205.83Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "245.675px 182.453px"
    },
    id: "elx3xg8wtu6ys",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.39,211.66a1.21,1.21,0,0,1-.14.2l-55.58-24.65a9.57,9.57,0,0,0-12,3.7l-59.42,95.34-2.2,1.27h0a1.79,1.79,0,0,1-1.7.19l61.11-98.06a9.6,9.6,0,0,1,12-3.71Z",
    style: {
      fill: "current",
      transformOrigin: "245.87px 236.487px"
    },
    id: "el6osve0rxzl8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eltzq3vmx2tx"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.18,199.58l.14-.12-54.09,86.8-2.2,1.27h0a1.82,1.82,0,0,1-1.7.19L236,198.3Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "209.325px 243.074px"
    },
    className: "animable",
    id: "el1rphxk4b4lx"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ellbzkh42edi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.39,211.67a1.21,1.21,0,0,1-.14.2l-55.59-24.66a9.57,9.57,0,0,0-12,3.7l-2.2-1.28a9.6,9.6,0,0,1,12-3.68Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "276.425px 198.503px"
    },
    className: "animable",
    id: "eluqildsdpzc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M314.73,111.33h0c-.12-.72-.5-.92-1-.58a2.89,2.89,0,0,0-.64.66l-.28.39L258,188.16l-8.19,11.41a4.67,4.67,0,0,1-4.51,1.69l-7.07-1.68-54-12.84a2.75,2.75,0,0,0-1.1,0,2,2,0,0,0-.41.13l1.49-.86,52,12.37L243.3,200a4.65,4.65,0,0,0,4.51-1.69l8.19-11.4,55.12-76.75a2.2,2.2,0,0,1,.62-.57L307,106.86l2-1.15,3.3,1.9A5.72,5.72,0,0,1,314.73,111.33Z",
    style: {
      fill: "current",
      transformOrigin: "248.725px 153.524px"
    },
    id: "elun0gtr7wrph",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el0q9knhprqsnn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258,188.16l-8.19,11.41a4.67,4.67,0,0,1-4.51,1.69l-7.07-1.68.14-.12.34-.54,4.63,1.1a4.65,4.65,0,0,0,4.51-1.69l8.11-11.28Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "248.115px 194.194px"
    },
    className: "animable",
    id: "elhr8wc50cga"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el1hvpbr1tsm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.26,107.61l-3.3-1.9-2,1.15,4.77,2.75h0a2.24,2.24,0,0,0-.62.57L256,186.93l-.08.11h0l2,1.11L312.8,111.8l.28-.39a2.89,2.89,0,0,1,.64-.66c.49-.34.87-.14,1,.58h0A5.72,5.72,0,0,0,312.26,107.61Z",
    style: {
      opacity: 0.1,
      transformOrigin: "285.32px 146.93px"
    },
    className: "animable",
    id: "elbpe0cluci6p"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M185.31,188.34l-11.76-6.8V282.83a5.59,5.59,0,0,0,2.51,4.35l2.82,1.63a5.61,5.61,0,0,0,5,0l1.41-.82Z",
    style: {
      fill: "current",
      transformOrigin: "179.43px 235.469px"
    },
    id: "el7jzdt6gurpd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elogmrykxf72"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.31,188.34l-11.76-6.8V282.83a5.59,5.59,0,0,0,2.51,4.35l2.82,1.63a5.61,5.61,0,0,0,5,0l1.41-.82Z",
    style: {
      opacity: 0.15,
      transformOrigin: "179.43px 235.469px"
    },
    className: "animable",
    id: "eloecr7s8gt5i"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M312.81,111.8v97.32a5,5,0,0,1-.78,2.54,5.2,5.2,0,0,1-1.47,1.64l-.09.06-.17.11-128.36,74.1h0a2.38,2.38,0,0,1-.49.23,3.19,3.19,0,0,1,0-.45V189a2.18,2.18,0,0,1,2.82-2.22l54,12.84,7.07,1.68a4.67,4.67,0,0,0,4.51-1.69L258,188.16Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "247.126px 199.8px"
    },
    id: "elr0lyk6mbg5j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.78,112v98.39a5.11,5.11,0,0,1-.78,2.54,5.48,5.48,0,0,1-1.47,1.65l-.1.05a1.53,1.53,0,0,1-.16.11L183.91,288.8h0a1.79,1.79,0,0,1-1.71.2,1.52,1.52,0,0,1-.75-1.2,3.19,3.19,0,0,1,0-.45V189a2.18,2.18,0,0,1,2.82-2.22l54,12.84,7.07,1.68a4.67,4.67,0,0,0,4.51-1.69L258,188.16l54.85-76.36.28-.39C314,110.12,314.78,110.36,314.78,112Z",
    style: {
      fill: "current",
      transformOrigin: "248.111px 199.858px"
    },
    id: "elhirj7xrr6oo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.27,214.7l.16-.11.1-.05a5.48,5.48,0,0,0,1.47-1.65,5.13,5.13,0,0,0,.77-2.49L258,188.16,296,224.09Z",
    style: {
      fill: "current",
      transformOrigin: "286.385px 206.125px"
    },
    id: "elyk73g8dzhe9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elk8yrknhbjd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.27,214.7l.16-.11.1-.05a5.48,5.48,0,0,0,1.47-1.65,5.13,5.13,0,0,0,.77-2.49L258,188.16,296,224.09Z",
    style: {
      opacity: 0.2,
      transformOrigin: "286.385px 206.125px"
    },
    className: "animable",
    id: "elxhrox4eeh7k"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M181.4,287.36a1.73,1.73,0,0,0,.78,1.65,1.79,1.79,0,0,0,1.71-.2h0l44.19-25.51,10.09-63.71L181.4,285.72Z",
    style: {
      fill: "current",
      transformOrigin: "209.779px 244.366px"
    },
    id: "el60aitn98pyc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elz9hubyttt9p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.63,190.9,182.17,289a1.73,1.73,0,0,1-.78-1.65v-1.63L235.62,199l.42-.67,5.39-8.64,0,0Z",
    style: {
      opacity: 0.15,
      transformOrigin: "212.504px 239.345px"
    },
    className: "animable",
    id: "el9hmn63ltqqj"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M314,212.89a5.48,5.48,0,0,1-1.47,1.65l-.1.05L183.91,288.8h0a1.79,1.79,0,0,1-1.71.2l61.46-98.13a9.66,9.66,0,0,1,12.09-3.71Z",
    style: {
      fill: "current",
      transformOrigin: "248.1px 237.734px"
    },
    id: "eli9zt9uauffg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,212.9a5.2,5.2,0,0,1-1.47,1.64l-.09.06L183.9,288.81h0a1.81,1.81,0,0,1-1.71.19l1.71-2.72,126.31-72.94.1-.06a5.11,5.11,0,0,0,1.33-1.44Z",
    style: {
      fill: "current",
      transformOrigin: "248.095px 250.486px"
    },
    id: "el8etcon41rvy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el8kyyxrg10aq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174,172.44l2,1.18a10,10,0,0,0-.47,2.74v6.36l-2-1.18v-6.37A10,10,0,0,1,174,172.44Z",
    style: {
      opacity: 0.15,
      transformOrigin: "174.765px 177.58px"
    },
    className: "animable",
    id: "elbb4ipdfoggd"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "186.08 186.42 184.2 185.97 182.71 186.83 180.65 185.64 175.58 182.72 177.55 181.55 186.08 186.42",
    style: {
      fill: "current",
      transformOrigin: "180.83px 184.19px"
    },
    id: "elz8mz79cmqnj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el5g0qayf6wmj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.08,186.42h0l-8.52-4.86-2,1.17,5.07,2.92,2.06,1.19h0a1.29,1.29,0,0,1,.38-.12,2.75,2.75,0,0,1,1.1,0l4.15,1L235.62,199l.42-.67Z",
    style: {
      opacity: 0.1,
      transformOrigin: "205.8px 190.28px"
    },
    className: "animable",
    id: "elormxnppt5w"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Notification--inject-72",
    className: "animable",
    style: {
      transformOrigin: "317.295px 215.518px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.5,190.34l-9.49-5.5h0l-.08-.05h0c-4.14-2.34-9.83-2-16.12,1.65-12.66,7.31-22.93,25.09-22.93,39.71,0,7.3,2.57,12.43,6.7,14.83h0l8.65,5,2-3.39a23.16,23.16,0,0,0,6.58-2.56c12.66-7.31,22.93-25.09,22.93-39.71a24.41,24.41,0,0,0-.72-5.86Z",
    style: {
      fill: "#53a14c",
      transformOrigin: "314.19px 214.643px"
    },
    id: "el2ojiohpls7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elowpz9m3j4fo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290.72,218.46a36.88,36.88,0,0,0-.87,7.7c0,7.3,2.57,12.43,6.7,14.83h0l8.65,5,2-3.39a23.16,23.16,0,0,0,6.58-2.56,36.68,36.68,0,0,0,6.25-4.61Z",
    style: {
      opacity: 0.15,
      transformOrigin: "304.94px 232.225px"
    },
    className: "animable",
    id: "elddx0dq5w1dd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M321.81,191.65c-12.66,7.31-22.93,25.09-22.93,39.71s10.27,20.55,22.93,13.24,22.93-25.09,22.93-39.71S334.48,184.34,321.81,191.65Z",
    style: {
      fill: "#6eb967",
      transformOrigin: "321.81px 218.125px"
    },
    id: "elc7wrtjo7ymp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.87,212v-5.62c0-6.41-3.9-9.36-8.7-6.58h0c-4.81,2.78-8.71,10.22-8.71,16.63v5a19.92,19.92,0,0,1-2.93,9.81v0a5.43,5.43,0,0,0-.71,2.57h0c0,1.61,1,2.36,2.19,1.66l20.33-11.74a5.26,5.26,0,0,0,2.19-4.19h0a2.05,2.05,0,0,0-.64-1.7l0,0C332.05,217.06,330.87,215,330.87,212Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "322.18px 217.243px"
    },
    id: "el2kgsr3s7gcj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.34,229c0,3.08-1.87,6.65-4.17,8s-4.18-.08-4.18-3.15Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "322.165px 233.255px"
    },
    id: "elwjosm9ut2yd",
    className: "animable"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMensajes);
export default __webpack_public_path__ + "static/media/mensajes.eda20700.svg";
export { ForwardRef as ReactComponent };